import React, { useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { TAGS as DEFAULT_TAGS } from '../data/homeBooks';

export default function TagBar({ active, onChange, query = '', onQueryChange, tags }) {
  const items = Array.isArray(tags) && tags.length ? tags : DEFAULT_TAGS;
  const [emblaRef, emblaApi] = useEmblaCarousel({ align: 'start', dragFree: true, containScroll: 'trimSnaps' });
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(true);

  const onSelect = useCallback((api) => {
    setCanPrev(api.canScrollPrev());
    setCanNext(api.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect(emblaApi);
    emblaApi.on('select', onSelect).on('reInit', onSelect);
  }, [emblaApi, onSelect]);

  return (
    <div className="tagbar">
      <button
        type="button"
        className="tagbar-arrow"
        onClick={() => emblaApi?.scrollPrev()}
        disabled={!canPrev}
        aria-label="Scroll tags left"
      >&#8592;</button>
      <div className="tagbar-viewport" ref={emblaRef}>
        <div className="tagbar-track">
          {items.map((t) => (
            <button
              key={t.id}
              type="button"
              className={`tagbar-tag ${active === t.id ? 'is-active' : ''}`}
              onClick={() => onChange(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      <button
        type="button"
        className="tagbar-arrow"
        onClick={() => emblaApi?.scrollNext()}
        disabled={!canNext}
        aria-label="Scroll tags right"
      >&#8594;</button>
      {onQueryChange && (
        <label className={`tagbar-search ${query ? 'has-query' : ''}`}>
          <svg className="tagbar-search-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
            <path d="M20 20l-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <input
            type="search"
            className="tagbar-search-input"
            placeholder="Search books"
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            aria-label="Search books"
          />
        </label>
      )}
    </div>
  );
}
